import axios from '../utils/index';
import { Pat, HttpResponse } from '@/typings/request';
const categoriesApi = {
    async getCategoryList(params: Pat) {
        return axios.get(`/task-category/list`, { params });
    },
    async addCategory(data: Pat) {
        return axios.post(`/task-category`, data);
    },
    async updateCategory(categoryId: string, data: Pat) {
        return axios.put(`/task-category/${categoryId}`, data);
    },
    async maxPosition() {
        return axios.get(`/task-category/max-position`);
    },
    async deleteCategory(categoryId: string) {
        return axios.delete(`/task-category/${categoryId}`);
    },
};

export default categoriesApi;
